import { render, staticRenderFns } from "./CDEKFilter.vue?vue&type=template&id=5ac541dc&scoped=true"
import script from "./CDEKFilter.vue?vue&type=script&lang=js"
export * from "./CDEKFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac541dc",
  null
  
)

export default component.exports